
export function GetItem()
{
    return(
        { 
            type: 'get_cart',
        }
    )
}